/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Complete from './Complete/index'
import No from './No/index'
import React from 'react'
import SetupPayment from './SetupPayment/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payersCompletedValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'completed',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payersCompletedValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SetupPayment'}>
<SetupPayment
  viewPath={`${viewPath}/SetupPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Complete'}>
<Complete
  viewPath={`${viewPath}/Complete`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}